import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import 'dayjs/locale/it';
import 'dayjs/locale/en';

const supportedLocales: Record<string, string> = {
  it: 'it',
  en: 'en',
};

const useDayjsLocale = () => {
  const { i18n } = useTranslation();
  const [locale, setLocale] = useState(supportedLocales[i18n.language] || 'en'); // Default fallback to "en"

  useEffect(() => {
    const dayjsLocale = supportedLocales[i18n.language] || 'en'; // Default fallback to "en"

    dayjs.locale(dayjsLocale);
    setLocale(dayjsLocale);
  }, [i18n.language]);

  return locale;
};

export default useDayjsLocale;
